export default __webpack_public_path__ + "static/media/lk.96b93cda.svg";